export default "__VITE_ASSET__00ba7798__"